var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 100,
    viewBox: "0 0 78 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8669 11.1331V2.43664C38.8669 0.250373 36.2434 -0.818467 34.7373 0.736209L21.1339 14.291C20.1622 15.2627 20.1622 16.7688 21.1339 17.7405L34.6887 31.2953C36.2434 32.8014 38.8669 31.7326 38.8669 29.5463V20.8498C54.9481 20.8498 68.0171 33.9188 68.0171 50C68.0171 53.8381 67.2883 57.579 65.8794 60.9313C65.1506 62.6803 65.6851 64.6723 66.9968 65.984C69.4746 68.4618 73.6528 67.5873 74.9645 64.3322C76.7621 59.9111 77.7338 55.0527 77.7338 50C77.7338 28.526 60.3409 11.1331 38.8669 11.1331ZM38.8669 79.1502C22.7857 79.1502 9.71672 66.0812 9.71672 50C9.71672 46.1619 10.4455 42.421 11.8544 39.0687C12.5832 37.3197 12.0487 35.3277 10.737 34.016C8.25922 31.5382 4.08103 32.4127 2.76927 35.6678C0.971673 40.0889 0 44.9473 0 50C0 71.474 17.3929 88.8669 38.8669 88.8669V97.5634C38.8669 99.7496 41.4904 100.818 42.9965 99.2638L56.5513 85.709C57.523 84.7373 57.523 83.2312 56.5513 82.2595L42.9965 68.7047C41.4904 67.1986 38.8669 68.2674 38.8669 70.4537V79.1502Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncFail);
export default __webpack_public_path__ + "static/media/sync-fail.09a37a83.svg";
export { ForwardRef as ReactComponent };